const KeenSlider = window.KeenSlider

const { setInitialised, useProgress } = window.BAO.Carousel.plugins

class ProductUgc extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.checkUgcLoaded()
  }

  checkUgcLoaded () {
    this.yotpoInterval = setInterval(() => {
      const slidesEl = this.querySelector(
        `.yotpo-pictures-gallery-images-wrapper`,
      )

      if (slidesEl) {
        const slideEls = this.querySelectorAll(`.yotpo-single-image-container`)

        slidesEl.classList.add(`keen-slider`)
        slideEls.forEach(el => el.classList.add(`keen-slider__slide`))

        clearInterval(this.yotpoInterval)
        this.carousel = this.setupCarousel()

        this.setupGA4Events()
      }
    }, 500)
  }

  setupCarousel () {
    const slidesEl = this.querySelector(
      `.yotpo-pictures-gallery-images-wrapper`,
    )
    this.classList.add(`prd-Ugc-active`)

    return new KeenSlider(
      slidesEl,
      {
        selector: `.yotpo-single-image-container`,
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1,
          spacing: 2,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 2,
              spacing: 2,
            },
          },
          '(min-width: 1201px)': {
            slides: {
              perView: 3,
              spacing: 2,
            },
          },
          '(min-width: 1601px)': {
            slides: {
              perView: 4,
              spacing: 2,
            },
          },
        },
      },
      [
        setInitialised(),
        useProgress({
          container: this.els?.progress?.element,
          progressbar: this.els?.progressbar?.element,
        }),
      ],
    )
  }

  setupGA4Events () {
    const slidesEl = this.querySelector(
      `.yotpo-pictures-gallery-images-wrapper`,
    )

    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return

          window.dataLayer.push({
            page_type: 'product_ugc',
            event: 'product_ugc_impression',
          })

          observer.unobserve(entry.target)
        })
      },
      {
        threshold: 0.8,
      },
    )
    observer.observe(slidesEl)

    slidesEl
      .querySelectorAll('.yotpo-single-image-container')
      .forEach(productUGC => {
        this.listeners.add(productUGC, 'click', event => {
          const productUgcUrl = event.target
            .querySelector('[data-original-src]')
            .getAttribute('data-original-src')

          window.dataLayer.push({
            page_type: 'product_ugc',
            event: 'product_ugc_click',
            click_url: `${productUgcUrl}`,
          })
        })
      })
  }
}

if (!customElements.get('product-ugc')) {
  customElements.define('product-ugc', ProductUgc)
}
